module.exports = __webpack_public_path__ + "static/media/logo@3x.c0a31c10.png";